import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericButtonModalData } from '../../interfaces/GenericButtonModalData';

@Component({
    selector: 'huge-monorepo-generic-button-modal',
    standalone: true,
    imports: [CommonModule, MaterialModule],
    templateUrl: './generic-button-modal.component.html',
    styleUrl: './generic-button-modal.component.scss',
})
export class GenericButtonModalComponent {
    /**
     * Buttons to be displayed in the modal
     */
    buttons: string[] = [];

    /**
     * Title text displayed in the modal header
     */
    title: string;

    /**
     * Subtitle text displayed below the title
     */
    subtitle: string;

    /**
     * Constructor for the GenericButtonModalComponent
     * @param dialogRef Reference to the dialog
     * @param data Data passed to the modal, including buttons and optional title
     */
    constructor(
        public dialogRef: MatDialogRef<GenericButtonModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: GenericButtonModalData
    ) {
        this.buttons = data.Buttons;
        if (data.Title) {
          this.title = data.Title;
        }
        if (data.Subtitle) {
          this.subtitle = data.Subtitle;
        }
    }

    /**
     * Handles button click events in the modal.
     * Closes the dialog and returns the clicked button.
     * @param button The button that was clicked
     */
    buttonClicked(button: string): void {
        this.dialogRef.close(button);
    }
}
